import {
  GET_LABSEGMENT,
  GET_LABSEGMENT_FAIL,
  GET_LABSEGMENT_SUCCESS,
  GET_LABSEGMENTS,
  GET_LABSEGMENTS_FAIL,
  GET_LABSEGMENTS_SUCCESS,
  ADD_NEW_LABSEGMENT,
  ADD_LABSEGMENT_SUCCESS,
  ADD_LABSEGMENT_FAIL,
  UPDATE_LABSEGMENT,
  UPDATE_LABSEGMENT_SUCCESS,
  UPDATE_LABSEGMENT_FAIL,
  DELETE_LABSEGMENT,
  DELETE_LABSEGMENT_SUCCESS,
  DELETE_LABSEGMENT_FAIL,
  SET_STATE_LABSEGMENT,
  UPDATE_LABSEGMENT_STATUS
} from "./actionTypes"

export const setState = ( loading ) => ({
  type: SET_STATE_LABSEGMENT,
  payload: loading,
})

export const getLabSegments = ( params ) => ({
  type: GET_LABSEGMENTS,
  payload: { params },
})

export const getLabSegmentsSuccess = (labsegments, totalPages, currentPage) => ({
  type: GET_LABSEGMENTS_SUCCESS,
  payload: {labsegments:labsegments, total:totalPages, currentPage:currentPage}
})

export const getLabSegmentsFail = error => ({
  type: GET_LABSEGMENTS_FAIL,
  payload: error,
})

export const addNewLabSegment = labsegment => ({
  type: ADD_NEW_LABSEGMENT,
  payload: labsegment,
})

export const addLabSegmentSuccess = labsegment => ({
  type: ADD_LABSEGMENT_SUCCESS,
  payload: labsegment,
})  

export const addLabSegmentFail = error => ({
  type: ADD_LABSEGMENT_FAIL,
  payload: error,
})

export const updateLabSegment = labsegment => ({
  type: UPDATE_LABSEGMENT,
  payload: labsegment,
})

export const updateLabSegmentStatus = labsegment => ({
  type: UPDATE_LABSEGMENT_STATUS,
  payload: labsegment,
})

export const updateLabSegmentSuccess = labsegment => ({
  type: UPDATE_LABSEGMENT_SUCCESS,
  payload: labsegment,
})

export const updateLabSegmentFail = error => ({
  type: UPDATE_LABSEGMENT_FAIL,
  payload: error,
})

export const deleteLabSegment = labsegment => ({
  type: DELETE_LABSEGMENT,
  payload: labsegment,
})

export const deleteLabSegmentSuccess = id => ({
  type: DELETE_LABSEGMENT_SUCCESS,
  id,
})

export const deleteLabSegmentFail = error => ({
  type: DELETE_LABSEGMENT_FAIL,
  payload: error,
})

export const getLabSegment = () => ({
  type: GET_LABSEGMENT,
})

export const getLabSegmentSuccess = labsegment => ({
  type: GET_LABSEGMENT_SUCCESS,
  payload: labsegment,
})

export const getLabSegmentFail = error => ({
  type: GET_LABSEGMENT_FAIL,
  payload: error,
})
